import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { T7eService } from '../../../t7e/t7e.service';
import { ContractService } from '../../../contract/contract.service';

@Component({
  selector: 'app-filter-warning',
  templateUrl: './filter-warning.component.html',
  styleUrls: ['./filter-warning.component.scss']
})
export class FilterWarningComponent implements OnInit {
  @Input() formgroup?: FormGroup
  @Input() warningFC?: FormControl

  constructor(
    private t7e: T7eService,
    private contractSvc: ContractService
  ) { }

  suspiciousContractsLoading$ = this.contractSvc.suspiciousContractsLoading$

  ngOnInit(): void {
    console.assert(this.warningFC, 'FilterWarningComponent: @Input warningFC kötelező')
    console.assert(this.formgroup, 'FilterWarningComponent: A formgroup megadása kötelező')
  }

  /** T7E */
  t7eLabel = this.t7e.getTranslation('app-filter-warning', 'label', 'innerText', null, null, 'Csak figyelmeztetéssel')
  t7eLoadingLabel = this.t7e.getTranslation('app-filter-warning', 'loading', 'innerText', null, null, 'Gyanúsak keresése...')
}
